module.exports = __webpack_public_path__ + "img/dot1.1e2e0444.png";